<div class="course-detail">
  @if (loading()) {
    <div class="detail-state">{{ 'catalog.loading' | translate }}</div>
  } @else if (notFound()) {
    <div class="detail-state error">{{ 'catalog.error' | translate }}</div>
  } @else if (course(); as c) {
    <button type="button" class="detail-back" (click)="back()">← {{ 'catalog.back' | translate }}</button>

    <div class="detail-head">
      @if (c.thumbnail_url) {
        <div class="detail-thumb"><img [src]="c.thumbnail_url | serverAuthUrl" [alt]="c.title" /></div>
      }
      <div class="detail-headtext">
        <h1 class="detail-title">{{ c.title }}</h1>
        @if (c.subtitle) { <p class="detail-subtitle">{{ c.subtitle }}</p> }
        <div class="detail-price">{{ c.price | currency: c.currency }}</div>
      </div>
    </div>

    @if (c.description) {
      <div class="detail-desc" [innerHTML]="c.description"></div>
    }

    @for (section of c.sections; track section.label) {
      <div class="detail-section">
        <p class="detail-section-label">{{ section.label }}</p>
        <ul class="detail-section-list">
          @for (item of section.items; track item) { <li>{{ item }}</li> }
        </ul>
      </div>
    }

    @if (c.is_bundle && c.members?.length) {
      <div class="detail-section">
        <p class="detail-section-label">{{ 'catalog.includes' | translate }}</p>
        <ul class="detail-section-list">
          @for (m of c.members; track m) { <li>{{ m }}</li> }
        </ul>
      </div>
    }

    @if (c.designed_for) {
      <div class="detail-for">
        <strong>{{ 'catalog.designed_for' | translate }}</strong>
        {{ c.designed_for }}
      </div>
    }

    @if (c.is_bundle && c.owned) {
      <p class="detail-owned-note">{{ 'catalog.bundle_owned' | translate }}</p>
    }

    <div class="detail-actions">
      @if (!c.is_bundle && c.accessible) {
        <button type="button" class="btn btn-secondary detail-open" (click)="open()">
          {{ 'catalog.open_course' | translate }}
        </button>
      }
      @if (c.buyable) {
        <button type="button" class="btn btn-primary detail-buy" (click)="buy()">
          @if (c.owned) {
            {{ 'catalog.buy_again' | translate }}
          } @else {
            {{ 'catalog.buy_and_checkout' | translate }}
          }
        </button>
      }
    </div>
  }
</div>
